import { RefreshCw, AlertCircle } from "lucide-react";

import { Skeleton } from "shared/ui/shadcn/skeleton";
import { clsxMerge } from "shared/lib/helpers";

interface BookedMeetingCalendarEventRibbonErrorPropsI {
  onRetry: () => void;
}

export const BookedMeetingCalendarEventRibbonStates = {
  Pending: () => (
    <div className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <Skeleton className="h-[18px] w-[18px] flex-shrink-0" />

        <div className="flex min-w-0 flex-1 items-center gap-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-36" />
        </div>
      </div>

      <Skeleton className="h-6 w-20 flex-shrink-0" />
    </div>
  ),
  Error: ({ onRetry }: BookedMeetingCalendarEventRibbonErrorPropsI) => (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <AlertCircle className="h-[18px] w-[18px] flex-shrink-0 text-red-500" />
        <span className="text-red-600 typography-body-4">
          Failed to load calendar event
        </span>
      </div>

      <button
        onClick={onRetry}
        className={clsxMerge(
          "flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap rounded px-3 py-1",
          "text-[#4474E3] transition-colors typography-body-5-medium hover:bg-[#4474E3]/10"
        )}
      >
        <RefreshCw size={14} />
        Retry
      </button>
    </div>
  ),
};
